/**
 * サイト全体で共通の設定
 * @type {Object}
 * @property {Number} siteWidth PC時のサイトの最小幅
 * @property {Number} breakpoint ブレイクポイント
 * @property {Number} scrollOffset グロナビとかが追従するときのスクロール値の調整用数値
 * @property {Object} scrollAnim スムーススクロール用の設定
 * @property {String | Number} scrollAnim.speed スムーススクロールのスピード
 * @property {String} scrollAnim.easing スムーススクロールのイージング
 */
export const CONFIG = Object.freeze({
	siteWidth: 1240,
	breakpoint: 736,
	scrollOffset: {
		get pc() {
			return $('.gHeader').outerHeight() + 20
		},
		get sp() {
			return $('.gHeader').outerHeight() + 20
		}
	},
	scrollAnim: {
		speed: ['slow', 'fast', 1000][2],
		easing: ['swing', 'linear'][0],
	},
});
